import { TranslationKey } from "@/types/translations";

interface AboutHeaderProps {
  translate: (key: TranslationKey) => string;
}

const stats = [
  { value: "300+", label: "about.stats.bookings" },
  { value: "1,000+", label: "about.stats.guests" },
  { value: "4.97", label: "about.stats.rating" },
];

const AboutHeader = ({ translate }: AboutHeaderProps) => (
  <section className="py-10 md:py-20 bg-white min-h-[60vh] md:h-[70vh] flex items-center">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
        <div className="lg:pr-8 text-center lg:text-left">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 md:mb-8">
            {translate("about.hero.title")}
          </h1>

          <div className="space-y-4 md:space-y-6">
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              {translate("about.hero.description.first")}
            </p>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              {translate("about.hero.description.second")}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-6 sm:space-y-0 sm:space-x-8 lg:space-x-12 mt-8 md:mt-12">
            {stats.map(({ value, label }) => (
              <div key={label} className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-gray-900 mb-1">
                  {value}
                </div>

                <div className="text-sm text-gray-600">
                  {translate(label as TranslationKey)}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:pl-8 order-first lg:order-last">
          <div className="rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://res.cloudinary.com/dlqntmmhh/image/upload/v1749353197/manzanillo_playa_xyklnh.jpg"
              alt="Manzanillo beach"
              className="w-full h-64 md:h-80 lg:h-96 object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutHeader;
